<ion-header>
  <ion-toolbar>
    <ion-title>{{ pageTitle }}</ion-title>
    <ion-button slot="end" fill="clear" [routerLink]="defaultHref">
      <ion-icon name="close" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-searchbar
    [(ngModel)]="searchQuery"
    (ionInput)="onSearchInput($event)"
    (ionClear)="onSearchInput({ target: { value: '' } })"
    placeholder="Search for images..."
    debounce="500"
  ></ion-searchbar>

  @if (errorMessage) {
    <ion-card>
      <ion-card-content>
        <p style="color: var(--ion-color-danger)">{{ errorMessage }}</p>
      </ion-card-content>
    </ion-card>
  }

  @if (isLoading) {
    <div style="text-align: center; padding: 2rem">
      <ion-spinner></ion-spinner>
      <p>Searching images...</p>
    </div>
  } @else if (photos.length === 0 && searchQuery.trim().length > 0 && !isLoading) {
    <ion-card>
      <ion-card-content>
        <p>No images found. Try a different search term.</p>
      </ion-card-content>
    </ion-card>
  } @else if (photos.length > 0) {
    <ion-grid>
      <ion-row>
        @for (photo of photos; track photo.id) {
          <ion-col size="6" size-md="4" size-lg="3">
            <ion-card button (click)="selectImage(photo)" class="image-card">
              <ion-img [src]="photo.urls.thumb" [alt]="getImageAlt(photo)" loading="lazy"></ion-img>
            </ion-card>
          </ion-col>
        }
      </ion-row>
    </ion-grid>

    <ion-infinite-scroll (ionInfinite)="loadMore($event)">
      <ion-infinite-scroll-content
        loadingText="Loading more images..."
      ></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  } @else {
    <ion-card>
      <ion-card-content>
        <p>Enter a search term to find images.</p>
      </ion-card-content>
    </ion-card>
  }
</ion-content>
